import React from "react"

const Twitter = () => {
	return (
		<svg width="18.031" height="13.007" viewBox="0 0 18.031 13.007">
			<path
				id="Forma_1_copy_4"
				data-name="Forma 1 copy 4"
				d="M17.532.24a8.04,8.04,0,0,1-2.351.8A3.912,3.912,0,0,0,12.483,0a3.51,3.51,0,0,0-3.7,3.284,2.917,2.917,0,0,0,.1.748A11,11,0,0,1,1.255.6a2.984,2.984,0,0,0-.5,1.65A3.2,3.2,0,0,0,2.4,4.985,4.053,4.053,0,0,1,.725,4.572v.041A3.414,3.414,0,0,0,3.691,7.834a4.12,4.12,0,0,1-1.67.056,3.676,3.676,0,0,0,3.454,2.282,8.037,8.037,0,0,1-4.594,1.4A8.664,8.664,0,0,1,0,11.531a11.45,11.45,0,0,0,5.67,1.476c6.8,0,10.523-5,10.523-9.345l-.011-.426a7.068,7.068,0,0,0,1.848-1.7,8.165,8.165,0,0,1-2.124.517A3.4,3.4,0,0,0,17.532.24Z"
				fill="#88c8bc"
			/>
		</svg>
	)
}

export default Twitter
